import { useMemo } from "react";
import { usePermissions } from "../../providers/PermissionsProvider";
export default function usePermissionsCheck({ permissions, groupIds }) {
    const { hasPermission, loading } = usePermissions();
    const hasRequiredPermissions = useMemo(() => {
        if (loading)
            return false;
        if (!permissions)
            return false;
        if (Array.isArray(permissions) && permissions.length === 0)
            return false;
        if (Array.isArray(groupIds) && groupIds.length === 0)
            return false;
        const permissionsToCheck = Array.isArray(permissions)
            ? permissions
            : [permissions];
        const groupIdsToCheck = Array.isArray(groupIds) ? groupIds : [groupIds];
        if (!groupIds)
            return permissionsToCheck.every((currentPermission) => hasPermission(currentPermission));
        return permissionsToCheck.some((currentPermission) => groupIdsToCheck.some((groupId) => hasPermission(currentPermission, groupId)));
    }, [loading, hasPermission, groupIds, permissions]);
    return {
        loading,
        hasRequiredPermissions,
    };
}
//# sourceMappingURL=index.js.map